import { WbaEvents } from "./wba-events";
import { flushWbaQueue, wbaSendEvent } from "./wba-send-event";
import type { TWbaEventCall, TWbaEventPayloadMap } from "./wba-types";

const counterId = import.meta.env.VITE_PUBLIC_WBA_COUNTER_ID ?? undefined;

let sdkInited = false;
let currentClientId: string | undefined;

const runWbaInit = (clientId = "0") => {
  const normalizedClientId = clientId || "0";

  if (sdkInited && currentClientId === normalizedClientId) {
    return;
  }

  wbaSendEvent([WbaEvents.INIT, {
    counterId,
    clientId: normalizedClientId,
  }]);

  currentClientId = normalizedClientId;
  sdkInited = true;
  flushWbaQueue();
};

export const initWba = (clientId = "0") => {
  if (!counterId) {
    return;
  }

  try {
    runWbaInit(clientId);
  } catch (error) {
    console.error("Error initializing WBA", error);
  }
};

export const syncWbaClientId = (clientId?: string | null) => {
  if (!counterId) {
    return;
  }

  try {
    runWbaInit(clientId || "0");
  } catch (error) {
    console.error("Error syncing WBA clientId", error);
  }
};

export const sendEvent = <E extends WbaEvents>(
  eventName: E,
  ...args: TWbaEventPayloadMap[E] extends void
    ? [oneTime?: boolean]
    : [params: TWbaEventPayloadMap[E], oneTime?: boolean]
): void => {
  if (!counterId) {
    return;
  }

  try {
    const oneTime = args.at(-1) === true;
    const params = (oneTime ? args.slice(0, -1) : args).find(
      (arg) => typeof arg !== "boolean",
    );

    wbaSendEvent(
      (params !== undefined ? [eventName, params] : [eventName]) as TWbaEventCall,
      oneTime,
    );
  } catch (error) {
    console.error(`Error sending event ${eventName}`, error);
  }
};
